import React from "react";
import "./index.css";

const Page = () => {
  return (
    <section className="join-container" aria-labelledby="join-title">
      <div className="join-empty-state">
        <svg
          className="join-illustration"
          viewBox="0 0 420 300"
          role="img"
          aria-labelledby="join-illustration-title"
        >
          <title id="join-illustration-title">游戏产品等待入驻</title>
          <defs>
            <linearGradient id="join-card-gradient" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#ffffff" />
              <stop offset="100%" stopColor="#fff4f4" />
            </linearGradient>
            <linearGradient id="join-controller-gradient" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#e02a32" />
              <stop offset="100%" stopColor="#b80d15" />
            </linearGradient>
            <filter id="join-shadow" x="-30%" y="-30%" width="160%" height="180%">
              <feDropShadow dx="0" dy="14" stdDeviation="14" floodColor="#8f1b20" floodOpacity="0.14" />
            </filter>
          </defs>

          <circle cx="210" cy="141" r="119" fill="#fff0f1" />
          <circle cx="210" cy="141" r="91" fill="none" stroke="#f7c9cc" strokeWidth="2" strokeDasharray="5 9" />

          <g opacity="0.9">
            <rect x="72" y="64" width="38" height="38" rx="10" fill="#ffffff" stroke="#f2b9bc" strokeWidth="2" transform="rotate(-9 91 83)" />
            <path d="M85 82h12M91 76v12" stroke="#d0121b" strokeWidth="3" strokeLinecap="round" />
            <rect x="309" y="78" width="32" height="32" rx="9" fill="#ffffff" stroke="#f2b9bc" strokeWidth="2" transform="rotate(11 325 94)" />
            <circle cx="325" cy="94" r="5" fill="#d0121b" />
            <path d="M100 209l5 10 11 2-8 8 2 11-10-5-10 5 2-11-8-8 11-2 5-10z" fill="#f3a8ac" />
            <path d="M329 201l4 8 9 1-7 6 2 9-8-4-8 4 2-9-7-6 9-1 4-8z" fill="#d0121b" opacity="0.75" />
          </g>

          <g filter="url(#join-shadow)">
            <rect x="122" y="63" width="176" height="143" rx="22" fill="url(#join-card-gradient)" stroke="#ffffff" strokeWidth="3" />
            <rect x="142" y="83" width="136" height="82" rx="13" fill="#f8dfe1" />
            <circle cx="175" cy="112" r="15" fill="#ffffff" />
            <path d="M167 113l6 6 11-14" fill="none" stroke="#d0121b" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="198" y="101" width="60" height="8" rx="4" fill="#e9aeb2" />
            <rect x="198" y="117" width="43" height="7" rx="3.5" fill="#edc8ca" />
            <rect x="142" y="178" width="53" height="8" rx="4" fill="#edc8ca" />
            <rect x="203" y="178" width="35" height="8" rx="4" fill="#f2d8da" />
          </g>

          <g filter="url(#join-shadow)">
            <path d="M158 182c-15 0-25 9-29 25l-9 35c-4 15 14 24 24 13l20-21h92l20 21c10 11 28 2 24-13l-9-35c-4-16-14-25-29-25H158z" fill="url(#join-controller-gradient)" />
            <circle cx="168" cy="215" r="23" fill="#ffffff" opacity="0.14" />
            <path d="M168 202v26M155 215h26" stroke="#ffffff" strokeWidth="7" strokeLinecap="round" />
            <circle cx="252" cy="208" r="6" fill="#ffffff" />
            <circle cx="269" cy="222" r="6" fill="#f8bdc0" />
            <rect x="201" y="207" width="18" height="7" rx="3.5" fill="#ffffff" opacity="0.65" />
          </g>

          <ellipse cx="210" cy="273" rx="104" ry="10" fill="#d0121b" opacity="0.08" />
        </svg>

        <h1 id="join-title">等待产品入驻</h1>
        <p>更多精彩游戏，敬请期待</p>
      </div>
    </section>
  );
};

export default Page;
